import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'

export default class Enum extends ApiCore {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/enum'
    super(store, path)
  }

  serviceList(filter, showProgress) {
    return this._request({
      action: 'service/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  operationList(filter, showProgress) {
    return this._request({
      action: 'operation/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  eventList(filter, showProgress) {
    return this._request({
      action: 'event/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  webServiceProvider(filter, showProgress) {
    return this._request({
      action: 'webServiceProvider/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  paymentProvider(filter, showProgress) {
    return this._request({
      action: 'paymentProvider/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
